import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTeamBudget = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/dashboard/team-budget-expense`);
};

export const useTeamBudget = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["team-budget-expense", churchId],
    queryFn: () => getTeamBudget({ churchId }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
